import { JsonServiceClient } from "@servicestack/client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as CreDtos from "../CRE.dtos";

export const homeSettingsApi = {
    get: () => {
        var client = new JsonServiceClient("");
        var query = new CreDtos.GetHome();
        const request = client.get(query);
        return Observable.from(request);
    },
    upsert: (homeSettings: CreDtos.HomeSettings) => {
        var client = new JsonServiceClient("");
        var query = new CreDtos.PostHome();
        query.homeSettings = homeSettings;
        const request = client.post(query);
        return Observable.from(request);
    }
};




// WEBPACK FOOTER //
// ./src/services/homeSettings.service.ts